import { AppLayout, AppLayoutProps } from '@cloudscape-design/components';
//import { useNavigationPanelState } from '@@/common/hooks/use-navigation-panel-state';
import NavigationPanel from '@@/products/portal/components/navigation-panel';
import React, { useState } from 'react';

export default function BaseAppLayout(props: AppLayoutProps) {
  //const [navigationPanelState, setNavigationPanelState] = useNavigationPanelState();

  // State to track if navigation panel is open
  const [navigationOpen, setNavigationOpen] = useState(true);

  // Handle changes to the navigation panel state
  const handleNavigationChange = (detail: { open: boolean }) => {
    setNavigationOpen(detail.open);
  };

  // Extract content from props and wrap it with main tag if it's not already wrapped
  const wrappedContent = (
    <main id='main-content' className='main-content' tabIndex={-1}>
      {props.content}
    </main>
  );

  return (
    <AppLayout
      headerSelector='#awsui-top-navigation'
      navigation={<NavigationPanel />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => handleNavigationChange(detail)}
      toolsHide={true}
      {...props}
      content={wrappedContent}
    />
  );
}
